import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
import { useGetUsers } from 'core/hooks/api'

// Styled Elements
import { TableWrapper } from './UsersTable.elements'

// Views
import { Table, LoadingTablePlaceholder } from 'views/components'

// Layouts
import UsersTableItem from '../UsersTableItem/UsersTableItem'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function UsersTable(props) {
  // Destructure
  const { setUsersLength, ui, actions } = props

  // Store States
  const { isPageTableUpdated } = ui
  const { setIsPageTableUpdated } = actions

  // Hooks
  const { getUsers, getUsersData, isGetUsersLoading } = useGetUsers()
  // const [currentUser] = useLocalStorage('userCredentials', {})

  // Local states
  const [users, setUsers] = useState([])

  // UseEffects
  useEffect(() => {
    getUsers()
  }, [])
  useEffect(() => {
    if (getUsersData) {
      setUsersLength(getUsersData.length)
      setUsers(getUsersData)
    }
  }, [getUsersData])
  useEffect(() => {
    if (isPageTableUpdated) {
      getUsers(getUsers)
      setIsPageTableUpdated(false)
    }
  }, [isPageTableUpdated])
  return (
    <TableWrapper>
      <Table hidePagination tableFilters={{ size: 0, page: 0 }} minWidth={900}>
        {isGetUsersLoading && <LoadingTablePlaceholder />}
        {!isGetUsersLoading &&
          users.length > 0 &&
          users.map((data, i) => (
            <UsersTableItem key={`${data.email} ${i + 1}`} values={data} setIsUpdated={setIsPageTableUpdated} />
          ))}
        {/* ) : (
          <div>{isGetReportsLoading && <LoadingTablePlaceholder />}</div>
        )} */}
      </Table>
    </TableWrapper>
  )
}

// Default Props
UsersTable.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
  setUsersLength: () => {},
}

// Proptypes Validation
UsersTable.propTypes = {
  filters: PropTypes.shape({
    reportsFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
  setUsersLength: PropTypes.func,
  actions: PropTypes.shape({
    setToBeUpdatedAccount: PropTypes.func,
    setAccountDirectoryFilters: PropTypes.func,
    setIsIndividualAccountDrawerOpen: PropTypes.func,
    setIsEntityAccountDrawerOpen: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setReportsFilters: PropTypes.func,
    showAlert: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersTable)
